export default {"src":"/_next/static/media/itz.a0a4ce19.svg","height":110,"width":404,"blurWidth":0,"blurHeight":0};